var map = {
	"./0.png": "ICv5",
	"./1.png": "vDBw",
	"./10.png": "jGJH",
	"./11.png": "oNfB",
	"./2.png": "0wGf",
	"./3.png": "7DQw",
	"./4.png": "xPQ0",
	"./5.png": "UM8i",
	"./6.png": "VZ2T",
	"./7.png": "4luK",
	"./8.png": "XiyF",
	"./9.png": "rLZ4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zbrA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot ^\.\/.*\.png$
// module id = zbrA
// module chunks = 0